export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/snei1ZhzzUEtd3mjFjuvQK/PAGINA_12.jpg',
    alt: 'Sample page This Is the Anatomy of an Underground Mine, a 3D cutaway labelling headframe and shaft, decline, adit, levels, sublevels, drifts, crosscuts, raises, ore and waste passes, stopes, pillars and sump',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7Ysi9FuG6ixDUXihGdjg2c/PAGINA_17.jpg',
    alt: "Sample page The Headframe Is the Mine's Landmark, a shaft cross-section showing headframe, hoist house, collar, shaft stations, skips, cages, loading station and shaft sump",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/knNrTsb1uaHyQ6MT55u1Bx/PAGINA_21.jpg',
    alt: 'Sample page How Long Is a Decline to Reach a Depth?, a hypothetical worked example calculating decline length for a 300 m depth at a 1 in 8 gradient',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/q9rvvfVAtNkoyNFy9JCFro/PAGINA_30.jpg',
    alt: 'Sample page The Mine Needs a Town Underground, a plan of underground infrastructure including workshop, fuel bay, crib room, refuge chamber, pump station, substation, magazines and stores',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tBfKxZ7ZL52r4Bvy3UW3aw/PAGINA_50.jpg',
    alt: 'Sample page Underground Mine Fundamentals Field Card, a checklist covering the orebody, layout, heading, key numbers, underground safety and five universal questions',
  },
];
